export default __webpack_public_path__ + "static/media/RTOmenu_active.0db99581.svg";